<template>
  <!-- Loading -->
  <div v-if="loading" class="d-flex justify-center" style="margin-top: 10%;">
    <Loader />
  </div>

  <!-- Treatments found -->
  <v-container
    v-else-if="treatments.length"
    fluid
    class="py-4 px-2 treatments-container"
  >
    <v-row dense>
      <!-- Title -->
      <v-col cols="12" class="mb-3">
        <v-card-title class="text-h6 font-weight-bold">
          Pending Treatment Details
        </v-card-title>
      </v-col>

      <!-- Treatment rows -->
      <v-col
        cols="12"
        v-for="(treatment, index) in treatments"
        :key="index"
      >
        <div>
          <span v-if="treatment.ToothNum">
            <v-icon small class="mr-1">mdi-tooth-outline</v-icon>
            {{ treatment.ToothNum }}
          </span>
          <span class="ml-2">{{ treatment.CategoryName || '—' }}</span>
        </div>
      </v-col>

      <!-- No results -->
      <v-col cols="12" v-if="!treatments.length">
        <v-alert type="info" text>
           No treatment details found.
        </v-alert>
      </v-col>
    </v-row>
  </v-container>

  <!-- No Open Dental Patient -->
  <div
    v-else
    class="d-flex justify-center align-center"
    style="min-height: 200px;"
  >
    <p
      class="text-red-darken-4 bg-red-lighten-5 pa-4 rounded-lg text-center font-weight-medium"
    >
      Contact is not an Open Dental patient.
    </p>
  </div>
</template>

<script>
import Loader from "../../UIComponents/Loader.vue";
import odService from "../../../services/odService";
import { mapGetters } from "vuex";
import dayjsMixin from "../../../mixins/dayjsMixin";

export default {
  name: "PendingTreatmentDetails",
  components: { Loader },
  mixins: [dayjsMixin],
  props: {
    contact: { type: Object, required: true },
  },
  data() {
    return {
      treatments: [],
      loading: false,
    };
  },
  computed: {
    ...mapGetters("frontdesk", ["odData"]),
  },
  watch: {
    contact: {
      immediate: true,
      handler(newContact) {
        if (newContact?.contact_id) {
          this.fetchTreatments(newContact);
        } else {
          this.resetData();
        }
      },
    },
  },
  methods: {
    async fetchTreatments(contact) {
      const matched = this.odData.find(
        (item) => item.contact_id === contact.contact_id
      );

      if (!matched) {
        console.warn("No matched record for contact_id:", contact.contact_id);
        this.resetData();
        return;
      }

      const patNum = matched?.od_json?.[0]?.PatNum;
      if (!patNum) {
        console.error("Missing patient number for matched record.");
        this.resetData();
        return;
      }

      this.loading = true;
      try {
        const res = await odService.pendingTreatmentDetails(patNum);
        this.treatments = res?.data?.data?.[0]?.od_json || [];
      } catch (err) {
        console.error("Failed to fetch treatments:", err);
        this.treatments = [];
      } finally {
        this.loading = false;
      }
    },

    resetData() {
      this.treatments = [];
      this.loading = false;
    },
  },
  beforeUnmount() {
    this.resetData();
  },
};
</script>

<style scoped>
.v-card {
  border-radius: 12px !important;
}

.treatments-container {
  max-height: 600px;
  overflow-y: auto;
}

.treatments-container::-webkit-scrollbar {
  width: 6px;
}
.treatments-container::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.treatments-container::-webkit-scrollbar-track {
  background: transparent;
}
</style>
